import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListItem,{attrs:{"link":"","to":_vm.item.path}},[_c(VListItemAction,[_c(VIcon,[_vm._v(_vm._s(_vm.item.icon))])],1),_c(VListItemContent,[_c(VListItemTitle,[_vm._v("\n      "+_vm._s(_vm.item.text)+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }